// extracted by mini-css-extract-plugin
export default {"container":"style_container__OqTIq","title":"style_title__FBoxl","tableInfo":"style_tableInfo__GKu65","prices":"style_prices__ExTc3","priceItem":"style_priceItem__jCitt"};